import { STM } from '../context/types';

export const pl_plStatements : STM[]  = [
  {
    "id":1,
    "valueKey": "samen1",
    "title":"częsta współpraca",
    "title_360_leadership": "stymuluje pracę w zespole",
    "title_360_workenv": "częste jest współdziałanie",
    "preferredType": "leadership"
  },
  {
    "id":2,
    "valueKey": "samen2",
    "title":"Interes zespołu stoi ponad interesem  poszczególnych osób",
    "title_360_leadership": "preferuje sukces zespołu przed swoim",
    "title_360_workenv": "interesy zespołu mają pierwszeństwo przed interesami indywidualnymi",
    "preferredType": "workenv"
  },
  {
    "id":3,
    "valueKey": "samen3",
    "title":"każdy stara się jak najlepiej dla zespołu",
    "title_360_leadership": "angażuje się w sprawy swojego zespołu",
    "title_360_workenv": "każdy daje z siebie wszystko dla zespołu",
    "preferredType": "leadership"
  },
  {
    "id":4,
    "valueKey": "conf1",
    "title":"nie wyraża się własnego zdania, jeśli może to prowadzić do konfliktu",
    "title_360_leadership": "nie wyraża swojego zdania, jeśli mogłoby to prowadzić do konfliktu",
    "title_360_workenv": "osobistej opinii nie wyraża się, jeśli mogłoby to prowadzić do konfliktu",
    "preferredType": "workenv"
  },
  {
    "id":5,
    "valueKey": "conf2",
    "title":"dokłada się wszelkich starań, aby utrzymać spokój",
    "title_360_leadership": "robi wszystko, aby unikać sporów",
    "title_360_workenv": "podejmuje się wszelkie starania, aby utrzymać pokój",
    "preferredType": "leadership"
  },
  {
    "id":6,
    "valueKey": "conf3",
    "title":"dokładnie przestrzega się istniejących zasad i norm",
    "title_360_leadership": "sprawdza, aby wszyscy szanowali reguły i normy",
    "title_360_workenv": "ściśle przestrzega się obowiązujących reguł i norm",
    "preferredType": "workenv"
  },
  {
    "id":7,
    "valueKey": "erken1",
    "title":"ludzie są szanowani przez współpracowników i kierowników",
    "title_360_leadership": "zapewnia, że wśród zespołu panuje szacunek wzajemny",
    "title_360_workenv": "ludzie są szanowani przez współpracowników i przełożonych",
    "preferredType": "workenv"
  },
  {
    "id":8,
    "valueKey": "erken2",
    "title":"docenia się ciężką pracę",
    "title_360_leadership": "docenia naszą pracę",
    "title_360_workenv": "docenia się ciężką pracę",
    "preferredType": "workenv"
  },
  {
    "id":9,
    "valueKey": "erken3",
    "title":"ceni się zaangażowanie i wyraża za nie wdzięczność",
    "title_360_leadership": "docenia nasze starania",
    "title_360_workenv": "ceni się i docenia zaangażowanie",
    "preferredType": "leadership"
  },
  {
    "id":10,
    "valueKey": "zorg1",
    "title":"każdy zawsze zachowuje się \"w porządku\" wobec innych",
    "title_360_leadership": "jest miłosierny i szanuje",
    "title_360_workenv": "zawsze postępuje się właściwie wobec innych",
    "preferredType": "leadership"
  },
  {
    "id":11,
    "valueKey": "zorg2",
    "title":"każdy przyczynia się do dobrego samopoczucia innych",
    "title_360_leadership": "preferuje atmosferę, w której każdy się czuje dobrze",
    "title_360_workenv": "przyczynia się do dobrostanu innych",
    "preferredType": "workenv"
  },
  {
    "id":12,
    "valueKey": "zorg3",
    "title":"ludzie pomagają sobie nawzajem",
    "title_360_leadership": "preferuje klimat współpracy",
    "title_360_workenv": "ludzie pomagają sobie nawzajem",
    "preferredType": "leadership"
  },
  {
    "id":13,
    "valueKey": "gelijk1",
    "title":"wszyscy traktowani są jednakowo",
    "title_360_leadership": "traktuje każdego w sposób sprawiedliwy",
    "title_360_workenv": "każdy jest traktowany równo",
    "preferredType": "workenv"
  },
  {
    "id":14,
    "valueKey": "gelijk2",
    "title":"wiek, pochodzenie lub płeć nie mają znaczenia",
    "title_360_leadership": "nie robi różnic w zależności od wieku, pochodzenia czy płci",
    "title_360_workenv": "wiek, pochodzenie czy płeć nie mają znaczenia",
    "preferredType": "workenv"
  },
  {
    "id":15,
    "valueKey": "gelijk3",
    "title":"ludzi ocenia się w oparciu o ich czyny, a nie charakter",
    "title_360_leadership": "ocenia nas na podstawie naszych działań",
    "title_360_workenv": "ocenia się po czynach, a nie po charakterze",
    "preferredType": "leadership"
  },
  {
    "id":16,
    "valueKey": "zelfsturing1",
    "title":"w znacznym stopniu można działać samodzielnie",
    "title_360_leadership": "sprawia, aby każdy mógł w dużej mierze decydować o swoim działaniu",
    "title_360_workenv": "w dużej mierze możliwe jest samodzielne działanie",
    "preferredType": "workenv"
  },
  {
    "id":17,
    "valueKey": "zelfsturing2",
    "title":"można samemu decydować o swoim sposobie pracy",
    "title_360_leadership": "pozwala nam decydować o naszym stylu pracy",
    "title_360_workenv": "można samodzielnie określać swój sposób pracy",
    "preferredType": "leadership"
  },
  {
    "id":18,
    "valueKey": "zelfsturing3",
    "title":"można samemu zaplanować sposób wykonania swojej pracy",
    "title_360_leadership": "pozwala nam decydować o naszym harmonogramie",
    "title_360_workenv": "można samodzielnie planować sposób wykonywania swojej pracy",
    "preferredType": "workenv"
  },
  {
    "id":19,
    "valueKey": "macht1",
    "title":"Mogę wpływać na zachowania innych",
    "title_360_leadership": "wpływa na moją pracę",
    "preferredType": "leadership"
  },
  {
    "id":20,
    "valueKey": "macht2",
    "title":"To ja decyduję, co należy zrobić",
    "title_360_leadership": "mówi, co powinno być zrobione",
    "preferredType": "leadership"
  },
  {
    "id":21,
    "valueKey": "macht3",
    "title":"Ja decyduję o tym, co się dzieje",
    "title_360_leadership": "decyduje, co powinno być zrobione",
    "preferredType": "disabled"
  },
  {
    "id":22,
    "valueKey": "voorspelbaar1",
    "title":"panuje porządek i regularność",
    "title_360_leadership": "zapewnia strukturę i regularność",
    "title_360_workenv": "panuje struktura i regularność",
    "preferredType": "workenv"
  },
  {
    "id":23,
    "valueKey": "voorspelbaar2",
    "title":"rzeczy zwykle dzieją się zgodnie z planem",
    "title_360_leadership": "sprawdza, aby wszystko zwykle zbiegało się z planem",
    "title_360_workenv": "sprawy zwykle przebiegają zgodnie z planem",
    "preferredType": "leadership"
  },
  {
    "id":24,
    "valueKey": "voorspelbaar3",
    "title":"można przestrzegać tradycyjnych wartości i sposobów myślenia",
    "title_360_leadership": "zapewnia szacunek dla tradycyjnych wartości i poglądów",
    "title_360_workenv": "można zachować tradycyjne wartości i sposoby myśleni",
    "preferredType": "workenv"
  },
  {
    "id":25,
    "valueKey": "prestatie1",
    "title":"można dawać z siebie wszystko",
    "title_360_leadership": "zachęca nas do dawania najlepszego z siebie",
    "title_360_workenv": "możliwe jest dawanie z siebie wszystkiego",
    "preferredType": "leadership"
  },
  {
    "id":26,
    "valueKey": "prestatie2",
    "title":"można całkowicie realizować swój potencjał",
    "title_360_leadership": "zachęca nas do pokazania, co możemy zrobić",
    "title_360_workenv": "można wykazać się pełnią swoich możliwości",
    "preferredType": "workenv"
  },
  {
    "id":27,
    "valueKey": "prestatie3",
    "title":"można się wyróżniać w swojej pracy",
    "title_360_leadership": "zachęca nas do osiągnięcia sukcesu w swojej pracy",
    "title_360_workenv": "można osiągać doskonałe wyniki w swojej pracy",
    "preferredType": "workenv"
  },
  {
    "id":28,
    "valueKey": "zelfontplooi1",
    "title":"można ciągle uczyć się nowych rzeczy",
    "title_360_leadership": "zachęca nas do ciągłego rozwoju",
    "title_360_workenv": "można stale uczyć się nowych rzeczy",
    "preferredType": "workenv"
  },
  {
    "id":29,
    "valueKey": "zelfontplooi2",
    "title":"można pogłębiać swoją wiedzę",
    "title_360_leadership": "zachęca nas do pogłębienia naszych umiejętności",
    "title_360_workenv": "można pogłębiać swoją wiedzę",
    "preferredType": "leadership"
  },
  {
    "id":30,
    "valueKey": "zelfontplooi3",
    "title":"można stale rozwijać się osobiście",
    "title_360_leadership": "pomaga innym w rozwoju",
    "title_360_workenv": "można stale rozwijać się osobowo",
    "preferredType": "workenv"
  },
  {
    "id":31,
    "valueKey": "duurzaam1",
    "title":"wykonuje się pracę dobrej jakości",
    "title_360_leadership": "sprawdza, aby zespół wykonywał jakość pracy",
    "title_360_workenv": "wykonywana jest praca wysokiej jakości",
    "preferredType": "leadership"
  },
  {
    "id":32,
    "valueKey": "duurzaam2",
    "title":"klienci i/lub inne osoby w firmie są szanowane",
    "title_360_leadership": "aktywnie zachęca zespół do szanowania klientów i innych relacji",
    "title_360_workenv": "szanuje się klientów i/lub inne osoby w biznesie",
    "preferredType": "workenv"
  },
  {
    "id":33,
    "valueKey": "duurzaam3",
    "title":"szanuje się ludzi, bezpieczeństwo i środowisko",
    "title_360_leadership": "sprawdza, abyśmy dbali o indywidualność, bezpieczeństwo i środowisko",
    "title_360_workenv": "uwzględnia się ludzi, bezpieczeństwo i środowisko",
    "preferredType": "workenv"
  },
  {
    "id":34,
    "valueKey": "integriteit1",
    "title":"przyjmuje się odpowiedzialność za swoje działania",
    "title_360_leadership": "sprawdza, abyśmy przyjmowali odpowiedzialność za swoje czyny",
    "title_360_workenv": "bierze się odpowiedzialność za swoje działania",
    "preferredType": "workenv"
  },
  {
    "id":35,
    "valueKey": "integriteit2",
    "title":"ludzie są uczciwi",
    "title_360_leadership": "jest uczciwy",
    "title_360_workenv": "ludzie są uczciwi",
    "preferredType": "workenv"
  },
  {
    "id":36,
    "valueKey": "integriteit3",
    "title":"szanuje się poufność",
    "title_360_leadership": "traktuje informacje osobiste i poufne z uwagą",
    "title_360_workenv": "szanuje się poufność",
    "preferredType": "leadership"
  },
  {
    "id":37,
    "valueKey": "innovatie1",
    "title":"można próbować nowych rzeczy",
    "title_360_leadership": "zachęca nas do próby nowych sposobów pracy",
    "title_360_workenv": "można próbować nowych rzeczy",
    "preferredType": "leadership"
  },
  {
    "id":38,
    "valueKey": "innovatie2",
    "title":"doświadcza się wiele nowego",
    "title_360_leadership": "zachęca nas do zdobywania nowych doświadczeń",
    "title_360_workenv": "ma się wiele nowych doświadczeń",
    "preferredType": "workenv"
  },
  {
    "id":39,
    "valueKey": "innovatie3",
    "title":"można poszukiwać wyzwań",
    "title_360_leadership": "zachęca nas do poszukiwania nowych wyzwań",
    "title_360_workenv": "można poszukiwać nowych wyzwań",
    "preferredType": "leadership"
  },
  {
    "id":40,
    "valueKey": "daadkracht1",
    "title":"podejmuje się inicjatywę w celu realizacji zadań",
    "title_360_leadership": "zachęca nas do podejmowania inicjatyw",
    "title_360_workenv": "podejmuje się inicjatywę w realizacji zadań",
    "preferredType": "workenv"
  },
  {
    "id":41,
    "valueKey": "daadkracht2",
    "title":"wysoki priorytet przydziela się robieniu wszystkiego, co się da, w celu uzyskania wyników",
    "title_360_leadership": "sprawdza, aby osiągnięto cele",
    "title_360_workenv": "priorytetem jest dążenie do uzyskania jak najlepszych rezultatów",
    "preferredType": "leadership"
  },
  {
    "id":42,
    "valueKey": "daadkracht3",
    "title":"podejmowane są wszelkie możliwe wysiłki w celu osiągnięcia wyznaczonych celów",
    "title_360_leadership": "robi wszystko, aby osiągnąć cele",
    "title_360_workenv": "podejmuje się wszelkie możliwe starania, aby osiągnąć wyznaczone cele",
    "preferredType": "leadership"
  }
]

export const extra360Pl_PlStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'podejmuje decyzje',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'szanuje i docenia różnice między członkami zespołu',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'udziela konstruktywnego feedbacku',
      preferredType: 'leadership',
    },
]
